// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Formik, Form } from 'formik';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Grid, TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { hasPemissions } from '../../../commons/utils';
import MultipleSnackbars from '../../MultipleSnackbars';
import { storeCreateNovedadesTurno } from '../../../store/novedadesTurnos';
import { DetalleNovedadTurno } from '../../novedadesTurno/detalle/DetalleNovedadTurno';
import validationSchema from '../../novedadesTurno/formModels/crear/validationSchema';
import formInitialValues from '../../novedadesTurno/formModels/crear/formInitialValues';
import createNovedadTurnoFormModel from '../../novedadesTurno/formModels/crear/createNovedadTurnoFormModel';
import { timeToClosedToast } from '../../../commons';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));



export const DetailDialogNovedadesTurnos = (props:any) =>  {



  const  [isSubmitting, setIsSubmitting] = React.useState(false);
  const  [btnText, setBtnText] = React.useState('Detalle Novedad Turno');

  


  const{ open, handleCloseModalDetalleNovedadTurno, buttons = false } = props;


  const { formId, formField } = createNovedadTurnoFormModel;

  const currentValidationSchema = validationSchema[0];

  const dispatch = useDispatch();


  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [data, setMsgErrors] = React.useState([]);
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

  const [areas_select, setAreasSelect] = React.useState([]);


  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


  
  const handleCloseT = () => {
    handleCloseModalDetalleNovedadTurno(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {     
   


    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.novedades', 'create', 'modulo.tiponovedades');


    if( !havePermissions ){
      
      // await dispatch( showIconRequestErrors() );

      const errors:any = [];
      errors.push({
        type: 'error',
        text: 'No tienes pemisos para (crear) tipo de novedad.'
      });

      await setMessagesAlerts(errors);
      
      

      return false;

                                                                    
        
    }

    setIsSubmitting(true);
    setBtnText('Un momento...');

    actions.setSubmitting(true);

    const response = await dispatch( storeCreateNovedadesTurno(values, setPercentajeArea) );


    setBtnText('Detalle Novedad Turno');

    setIsSubmitting(false);


    if (!response.ok && response.code == 400  ) { 
    
      const errors:any = [];

      response.errors.forEach( (element:any) => {
          
           errors.push({
             type: 'error',
             text: element
           })
      });

         
         setMessagesAlerts(errors);
         return false;
    }


    if ( response.ok && response.statusCode == 201 ) {

        setAlertSnack(true);

        await setMessageAlertSnack(response.message);

        setTypeAlertSnack('success')

        actions.resetForm();
        actions.setSubmitting(false);
        handleCloseModalDetalleNovedadTurno(false);
        return false;

    }

    if ( !response.ok && response.statusCode == 200 ) {

      setAlertSnack(true);

      await setMessageAlertSnack(response.message);

      setTypeAlertSnack('error')

      return false;

    }


    if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {


      // await dispatch( showIconRequestErrors() );

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( crear ) turnos.');

      setTypeAlertSnack('error')

      return false;

    }
    
    
    

  }

  return (
    <React.Fragment>

     
      {/* <MessagesDrawerRight data={data} title={''} /> */}
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />


      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={message_alert_snack} severity={type_alert_snack}/>
      
      <BootstrapDialog
        onClose={handleCloseT}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Detalle  Novedad Turno 
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseT}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
                 <Form id={formId}>
                 <DetalleNovedadTurno formField={formField}/>
                 
                  
                  
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}